<template>
	<div class="invoice-reminder" :class="{ collapsed: isCollapsed }" v-if="isVisible">
		<div class="reminder-content" v-if="!isCollapsed">
			<div class="reminder-header">
				<span class="title">发票提醒</span>
				<i class="el-icon-close close-icon" @click="toggleCollapse"></i>
			</div>
			<div class="reminder-body" v-html="remindText"></div>
			<div class="reminder-footer">
				<el-button size="small" type="primary" @click="noRemind">不再提醒</el-button>
				<el-button size="small" class="btn-collapse" @click="toggleCollapse">收起</el-button>
			</div>
		</div>
		<div class="reminder-tab" v-else @click="toggleCollapse">
			<div class="tab-text">发票提醒</div>
		</div>
	</div>
</template>

<script>
	import {
		GetInvoiceRemind,
		NoInvoiceRemindThisMonth
	} from '@/api/home'

	export default {
		name: 'InvoiceReminder',
		data() {
			return {
				isVisible: false,
				isCollapsed: false,
				remindText: ''
			}
		},
		created() {
			this.getInvoiceRemind()
		},
		methods: {
			async getInvoiceRemind() {
				let {
					data,
					code
				} = await GetInvoiceRemind({})
				if (code == 0 && data) {
					this.remindText = data
					this.isVisible = true
				}
			},
			toggleCollapse() {
				this.isCollapsed = !this.isCollapsed
			},
			async noRemind() {
				let res = await NoInvoiceRemindThisMonth()
				if (res.code == 0) {
					this.isVisible = false
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.invoice-reminder {
		position: fixed;
		right: 20px;
		top: 35%;
		transform: translateY(-50%);
		z-index: 2000;
		transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
		box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
		border-radius: 8px;
		background-color: #fff;

		&.collapsed {
			right: 0;
			border-radius: 8px 0 0 8px;
			box-shadow: -2px 4px 12px rgba(0, 0, 0, 0.1);
		}

		.reminder-content {
			width: 340px;
			display: flex;
			flex-direction: column;
			overflow: hidden;
			border-radius: 8px;

			.reminder-header {
				padding: 14px 16px;
				background-color: #fce8ec;
				color: #e71d43;
				display: flex;
				justify-content: space-between;
				align-items: center;

				.title {
					font-weight: bold;
					font-size: 16px;
				}

				.close-icon {
					cursor: pointer;
					font-size: 16px;
					color: #e71d43;

					&:hover {
						opacity: 0.8;
					}
				}
			}

			.reminder-body {
				padding: 16px;
				font-size: 14px;
				color: #333;
				line-height: 1.6;
				max-height: 300px;
				overflow-y: auto;
			}

			.reminder-footer {
				padding: 12px 16px;
				display: flex;
				justify-content: flex-end;
				border-top: 1px solid #f0f0f0;

				.el-button--primary {
					background-color: #e71d43;
					border-color: #e71d43;

					&:hover {
						background-color: #f04a66;
						border-color: #f04a66;
					}
				}

				.btn-collapse {
					&:hover {
						color: #00266D !important;
						border-color: #00266D !important;
						background-color: #f0f4f8 !important;
					}
				}
			}
		}

		.reminder-tab {
			width: 36px;
			padding: 16px 0;
			background-color: #e71d43;
			color: #fff;
			cursor: pointer;
			display: flex;
			justify-content: center;
			align-items: center;
			border-radius: 8px 0 0 8px;

			.tab-text {
				writing-mode: vertical-lr;
				letter-spacing: 2px;
				font-size: 14px;
				font-weight: 500;
			}

			&:hover {
				background-color: #f04a66;
			}
		}
	}
</style>